import AssistChip from 'LuxKit/Chips/AssistChip'
import { OfferPageActions } from 'contexts/OfferPage/offerPageStateReducer'
import withOfferPageState from 'contexts/OfferPage/withOfferPageState'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import { useCallback, useRef } from 'react'
import { useIntl } from 'react-intl'
import CalendarDurationDropdown from './CalendarDurationDropdown'
import DropdownList from 'LuxKit/Dropdown/List/DropdownList'

interface Props {
  duration: number
  open: boolean
  rooms?: Array<App.Occupants>
  adultsNumber: number
  displayPricingAsPerPerson: boolean
  flights: boolean
}

function CalendarDurationSelect(props: Props) {
  const { duration, open, rooms, adultsNumber, displayPricingAsPerPerson, flights } = props
  const intl = useIntl()
  const dispatch = useOfferPageDispatch()
  const durationTriggerRef = useRef<HTMLButtonElement>(null)

  const onToggleOpen = useCallback(() => {
    dispatch({ type: OfferPageActions.toggleSubFilter, filter: 'duration' })
  }, [dispatch])

  const onClose = useCallback(() => {
    dispatch({ type: OfferPageActions.closeSubFilter })
  }, [dispatch])

  const durationTitle = intl.formatMessage({
    id: '9f95hJNnj9UxKA94IxRl',
    defaultMessage: 'How long do you want to stay?',
    description: 'Title for duration selection dropdown in bedbank date picker',
  })

  return (
    <>
      <AssistChip variant="outline" size="medium" ref={durationTriggerRef} onClick={onToggleOpen}>
        {intl.formatMessage({
          id: 'Ge1SGC7Uol47JmIGJIpr',
          defaultMessage: '{count, plural, one {# night} other {# nights}}',
          description: 'Number of nights selected for duration chip in bedbank date picker',
        }, { count: duration })}
      </AssistChip>
      <DropdownList
        size="M"
        open={open}
        triggerRef={durationTriggerRef}
        anchorRef={durationTriggerRef}
        title={durationTitle}
        onClose={onClose}
      >
        <CalendarDurationDropdown
          displayPricingAsPerPerson={displayPricingAsPerPerson}
          adultsNumber={adultsNumber}
          rooms={rooms}
          flights={flights}
          onClose={onClose}
        />
      </DropdownList>
    </>
  )
}

export default withOfferPageState((state) => ({
  duration: state.duration,
  open: state.activeSubFilter === 'duration',
}), CalendarDurationSelect)
